import { WWW_URLS } from '../../../backendServices/urls';
import   React                       , 
       { useEffect                   ,
         useState                    }  from 'react';


import { useLocation                 ,
         useNavigate                 }  from 'react-router-dom';

import { Dispatch                    }  from 'redux';
import { useDispatch                 }  from 'react-redux';

import   styles                         from './login.module.scss';
import { fetchLoginCommunityMessages ,
         CommunityMessage             }  from '../../../backendServices/communityManagment/api';


import { appVersion                  ,
         buildDate                   }  from '../../../config/build_infos';

import { initAuthentication          ,
         setLogin                    , 
         setToken                    ,
         setAdmin                }  from '../../../store/adminAuthenticationManagment/actions';


import { useTypedSelector            }  from '../../../store/useTypeSelector';
import { RootState                   }  from '../../../store/generalReducer'; // Importez le type RootState

import { postAdminAuthentication     ,
         getAdminInfosByEmail        }  from '../../../backendServices/adminManagment/api';

import { postAdminEvent              }  from '../../../backendServices/adminFrontEventManagment/api';

import { postAuthenticationResult    ,
         postEmailValidationResend   ,
         getPasswordResetRequest     ,
         EMAIL_NOT_VALIDATED_MARKER  }  from '../../../backendServices/adminManagment/api';


export const Login = () => {
  
  const   dispatch: Dispatch<any> = useDispatch();
  const   navigate                = useNavigate();
  // Valeur inutilisée, mais l'abonnement est conservé : le retirer changerait
  // la fréquence de rendu du composant.
  useLocation();
  
  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);

  const [ email                 , setEmail                 ] = useState('');
  const [ password              , setPassword              ] = useState('');
  
  const [ showPassword          , setShowPassword          ] = useState (false);

  const [ version               , setVersion               ] = useState(0);

  const [ showWaitMessage       , setShowWaitMessage       ] = useState (false);
  const [ showErrorMessage      , setShowErrorMessage      ] = useState (0);
  const [ serverErrorMessage    , setServerErrorMessage    ] = useState ('');

  // Renvoi du mail de validation, proposé quand la connexion est refusée pour cette raison.
  const [ resendInProgress     , setResendInProgress      ] = useState (false);
  const [ resendMessage        , setResendMessage         ] = useState<{ ok: boolean , text: string } | null>(null);

  // « Mot de passe oublié » : même mécanique que le portail. Message volontairement identique
  // que l'adresse existe ou non.
  const [ forgotInProgress   , setForgotInProgress      ] = useState (false);
  const [ forgotMessage      , setForgotMessage         ] = useState<string | null>(null);

  const handleForgotPassword = async () => {

    if ( forgotInProgress ) return;

    if ( email.trim() === '' )
     {
      setForgotMessage ( "Saisissez d'abord votre adresse e-mail ci-dessus, puis cliquez de nouveau sur « Mot de passe oublié »." );
      return;
     }

    setForgotInProgress ( true );
    setForgotMessage ( null );

    const processed = await getPasswordResetRequest ( email.trim() );

    setForgotMessage ( processed
                       ? "Si un compte existe pour cette adresse, un e-mail de réinitialisation vient d'être envoyé."
                       : "Le serveur est injoignable. Vérifiez votre connexion, puis réessayez." );
    setForgotInProgress ( false );
  };

  const handleResendValidation = async () => {

    if ( resendInProgress ) return;

    setResendInProgress ( true );
    setResendMessage ( null );

    const result = await postEmailValidationResend ( email , password );

    setResendMessage ( { ok: result.code > 0 , text: result.comment } );
    setResendInProgress ( false );
  };

  /*
  useEffect(() => {

    window.scroll(0, 0);

    if ( authentication.login !== "" &&
         authentication.token !== "" )
          {
           navigate ( '/bureau' );
          }

  }, [ authentication.login            , 
       authentication.token            , 
       authentication.numberOfAttempts                ,
	   showWaitMessage] ); 
  */

  useEffect(() => {
  

    if ( authentication.login !== "" &&
         authentication.token !== "" )
     {
      navigate ("/bureau");
     }
  }, [] );


  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setEmail ( e.target.value ) 
  //  const retour: Validation = checkEmail ( e.target.value )
 //   setMessageEmail ( retour.comment );
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setPassword ( e.target.value );
  //  const retour: Validation = checkPassword ( e.target.value )
  //  setMessagePassword ( retour.comment );
  };

  // Un formulaire : la touche Entrée connecte depuis l'un ou l'autre champ,
  // comme le bouton. Pas de seconde tentative tant que la première court.
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {

    e.preventDefault();
    if ( showWaitMessage ) return;
    setShowWaitMessage (true);
    makeAuthentication ();
  }


  const checkAll = async (): Promise<boolean> => {
/*
    const retour01 = checkEmail    ( email )
    const retour02 = checkPassword ( password )

    setMessageEmail       ( retour01.comment );
    setMessagePassword    ( retour02.comment );
*/
    const code:number = 0 // retour01.code +                         retour02.code;

    return ( code === 0 );                        
  }

  const makeAuthentication = async () => {
 
    setShowErrorMessage ( 0 );
    setServerErrorMessage ( '' );
    setResendMessage ( null );

    const check = await checkAll ()
 
    if ( check )
     {
      const authenticationResult = await postAdminAuthentication ( email , password )

      if ( authenticationResult.code === 1 )
            {
             // Réactivé le 22/09/2026 : le bug qui rendait ce mécanisme instable (findByEmail
             // incompatible côté AuthenticationResult) est corrigé. Seule la connexion
             // réussie est tracée pour l'instant (échec/erreur réseau restent coupés,
             // cf. branche else ci-dessous) — best effort, jamais attendu.
             postAuthenticationResult ( email , "Succès" , "Régie Web Kleon" );

             dispatch ( setLogin ( email                        ) );
             dispatch ( setToken ( authenticationResult.payload ) );

             const adminResult = await getAdminInfosByEmail ( email )

             if ( adminResult.code === 1 )
                   {
                    dispatch ( setAdmin ( adminResult.payload ) );

                    postAdminEvent ( "__AUTH__:" + window.location.pathname + window.location.search + window.location.hash + ":Success", email );

                    navigate ("/bureau");
                   }
              else {
                    dispatch ( initAuthentication(false) );

                    // L'authentification a réussi — c'est la lecture du profil qui a échoué.
                    // Le message générique de l'écran dirait « identifiant ou mot de passe
                    // incorrect », ce qui est faux et pousserait à ressaisir un mot de passe
                    // qui, lui, est bon.
                    setServerErrorMessage ( "Connexion acceptée, mais votre profil n'a pas pu être chargé. Réessayez dans un instant." );

                    setShowErrorMessage ( 1 );
			        setShowWaitMessage (false);
		            setVersion ( version + 1 )
                   }
            }
       else {
             // Traçage UserActionLog désactivé côté créateur (2026-09-22) — cf. commentaire
             // sur la branche succès ci-dessus.
             // postAuthenticationResult ( email , authenticationResult.code === -201 ? "Erreur réseau" : "Echec" );

             dispatch ( initAuthentication(false) );

             // Un refus motivé par le serveur — compte en attente, suspendu, désactivé —
             // remplace le message générique : lui seul dit à la personne ce qui se passe
             // et qu'il est inutile de retenter son mot de passe.
             setServerErrorMessage ( authenticationResult.comment );

             setShowErrorMessage ( 1 );
			 setShowWaitMessage (false);
		     setVersion ( version + 1 )
            }
					
   }
  }

  // L'écran reprend celui de l'app Kleon Studio (LoginView.swift) : fond noir
  // traversé de deux lueurs, violette et cyan, qui dérivent lentement (son
  // AuroraBackground), une carte en verre dépoli, des champs arrondis et un
  // bouton cyan. Toujours sombre, quel que soit le thème de la régie : c'est
  // l'entrée de l'outil de direct, comme l'accueil des apps.
  return (

    <div className={styles.root}>

      <div className={styles.aurora} aria-hidden="true">
        <span className={styles.glowViolet} />
        <span className={styles.glowCyan}   />
        <span className={styles.glowBlue}   />
      </div>

      <main className={styles.content}>

        {/* La vitrine : ce que Kleon permet, pour qui arrive sans compte. Sur
            téléphone elle passe sous la connexion, en version courte, pour ne
            pas gêner ceux qui viennent travailler. */}
        <section className={styles.showcase}>

          <img className={styles.logo} src="/images/logo5.png" alt="Kleon.tv" />

          <span className={styles.badge}><IconSparkles /> Programme bêta · création gratuite</span>

          {/* Une accroche courte, sur deux lignes : le bénéfice. Les sources,
              elles, se lisent mieux en étiquettes juste dessous qu'en fin de
              phrase. */}
          <h1 className={styles.headline}>
            Réalisez vos directs <span className={styles.accent}>comme à la télé</span>
          </h1>

          <p className={styles.lead}>
            Toutes vos caméras et sources externes réunies dans une seule régie,
            diffusées en direct sur Kleon.tv et vos réseaux sociaux.
          </p>

          <ul className={styles.sources} aria-label="Sources acceptées">
            <li><IconPhone /> Téléphone</li>
            <li><IconWebcam /> Webcam</li>
            <li><IconCamera /> Caméra pro · RTMP</li>
            <li><IconScreen /> OBS</li>
            <li><IconBroadcast /> IPTV…</li>
          </ul>

          {/* Le différenciateur, mis en avant : n'importe quel téléphone,
              n'importe où, devient une caméra du direct. */}
          <div className={styles.highlight}>
            <span className={styles.highlightIcon}><IconGlobe /></span>
            <div>
              <strong>Des caméras partout dans le monde</strong>
              <p>
                Invitez n'importe quel possesseur de smartphone par un simple lien,
                ou faites appel aux cadreurs de la communauté Kleon pour couvrir
                un événement, où qu'il soit.
              </p>
            </div>
          </div>

          <ul className={styles.benefits}>
            <li>
              <span className={styles.benefitIcon}><IconMixer /></span>
              <div><strong>Une vraie régie</strong><p>Mosaïque des angles, scènes en un clic, habillage et médias.</p></div>
            </li>
            <li>
              <span className={styles.benefitIcon}><IconHeadset /></span>
              <div><strong>Intercom</strong><p>Parlez à vos cadreurs pendant le direct, sans quitter la régie.</p></div>
            </li>
            <li>
              <span className={styles.benefitIcon}><IconBroadcast /></span>
              <div><strong>Diffusez partout</strong><p>Kleon.tv, et en même temps YouTube, Facebook et vos réseaux.</p></div>
            </li>
            <li>
              <span className={styles.benefitIcon}><IconCalendar /></span>
              <div><strong>Une chaîne en continu</strong><p>Vos vidéos et votre écran d'attente entre deux directs.</p></div>
            </li>
          </ul>

        </section>

        <section className={styles.access}>

          {/* Sur téléphone la vitrine passe dessous : le logo remonte ici. */}
          <img className={styles.mobileLogo} src="/images/logo5.png" alt="Kleon.tv" />

          <form className={styles.card} onSubmit={handleSubmit} noValidate>

            <div className={styles.cardHeader}>
              <h2 className={styles.title}>Connexion à la régie pro</h2>
              <p className={styles.subtitle}>Pilotez vos chaînes et directs</p>
            </div>

            <label className={styles.field}>
              <span className={styles.srOnly}>Identifiant</span>
              <IconMail />
              <input type           = "text"
                     inputMode      = "email"
                     autoCapitalize = "none"
                     spellCheck     = {false}
                     value          = {email}
                     onChange       = {handleEmailChange}
                     placeholder    = "nom@exemple.fr"
                     autoComplete   = "username"
                     autoFocus />
            </label>

            <label className={styles.field}>
              <span className={styles.srOnly}>Mot de passe</span>
              <IconLock />
              <input type         = {showPassword ? 'text' : 'password'}
                     value        = {password}
                     onChange     = {handlePasswordChange}
                     placeholder  = "Mot de passe"
                     autoComplete = "current-password" />
              <button type       = "button"
                      className  = {styles.eye}
                      onClick    = {() => setShowPassword ( !showPassword )}
                      aria-label = {showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}>
                {showPassword ? <IconEyeOff /> : <IconEye />}
              </button>
            </label>

            {
              ( showErrorMessage === 1 ) &&
              (
                <p className={styles.error} role="alert">
                  {serverErrorMessage !== '' ? serverErrorMessage : "Identifiant ou mot de passe incorrect."}
                </p>
              )
            }

            {
              ( showErrorMessage === 1 && serverErrorMessage.includes ( EMAIL_NOT_VALIDATED_MARKER ) ) &&
              (
                <div>
                  <button type      = "button"
                          className = {styles.resendButton}
                          disabled  = {resendInProgress}
                          onClick   = {handleResendValidation}>
                    {resendInProgress ? 'Envoi…' : 'Renvoyer le mail de validation'}
                  </button>
                  {
                    resendMessage &&
                    <p className={resendMessage.ok ? styles.resendOk : styles.error} role="status">
                      {resendMessage.text}
                    </p>
                  }
                </div>
              )
            }

            <div>
              <button type      = "button"
                      className = {styles.forgotLink}
                      disabled  = {forgotInProgress}
                      onClick   = {handleForgotPassword}>
                {forgotInProgress ? 'Envoi…' : 'Mot de passe oublié ?'}
              </button>
              { forgotMessage && <p className={styles.resendOk} role="status">{forgotMessage}</p> }
            </div>

            <button type="submit" className={styles.submit} disabled={showWaitMessage}>
              {showWaitMessage
                ? <><span className={styles.spinner} aria-hidden="true" /> Connexion…</>
                : 'Me connecter'}
            </button>

            {/* Pour qui n'a pas encore de compte : l'inscription se fait sur
                kleon.io, dans un nouvel onglet. Bouton secondaire — « Me
                connecter » reste le seul bouton plein de la page. Le lien est
                suivi, pour mesurer ce qu'il apporte. */}
            <div className={styles.join}>
              <span className={styles.joinLabel}>Pas encore de compte ?</span>
              <a className={styles.joinButton}
                 href={`${WWW_URLS.BetatestWebsite}/?utm_source=regie-login&utm_medium=bouton&utm_campaign=devenez-createur`}
                 target="_blank"
                 rel="noopener">
                Devenez créateur Kleon <IconArrow />
              </a>
            </div>

          </form>

          <LoginAnnouncements />

          <p className={styles.version}>Version {appVersion} · {buildDate}</p>

        </section>

      </main>

    </div>
   );

}

// Annonces du Superadmin sous le panneau de connexion : les messages envoyés avec
// « Afficher sur la page de connexion ». Relevé à l'arrivée puis chaque minute ;
// un échec ne montre rien — la connexion ne dépend jamais de ce bandeau.
const LoginAnnouncements = () => {
  const [ messages , setMessages ] = useState<CommunityMessage[]>([]);

  useEffect(() => {
    let alive = true;
    const load = () => {
      fetchLoginCommunityMessages()
        .then(list => { if (alive) setMessages(list.slice(0, 3)); })
        .catch(() => {});
    };
    load();
    const timer = window.setInterval(load, 60000);
    return () => { alive = false; window.clearInterval(timer); };
  }, []);

  if (messages.length === 0) return null;

  return (
    <div className={styles.announcements} role="region" aria-label="Informations">
      {messages.map(m => (
        <article key={m.id} className={`${styles.announcement} ${m.priority ? styles.announcementPriority : ''}`}>
          <span className={styles.announcementIcon} aria-hidden="true"><IconMegaphone /></span>
          <div className={styles.announcementBody}>
            <span className={styles.announcementTag}>{m.priority ? 'Information importante' : 'Information'}</span>
            <h3 className={styles.announcementTitle}>{m.title}</h3>
            <p className={styles.announcementText}>{m.message}</p>
            <time className={styles.announcementDate} dateTime={m.creationDate}>
              {new Date(m.creationDate).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
            </time>
          </div>
        </article>
      ))}
    </div>
  );
};

// Pictogrammes des champs, dessinés au trait comme les SF Symbols de l'app.
const Icon = ({ children }: { children: React.ReactNode }) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
       strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);
const IconMail   = () => <Icon><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></Icon>;
const IconLock   = () => <Icon><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></Icon>;
const IconEye    = () => <Icon><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></Icon>;
const IconSparkles  = () => <Icon><path d="M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8z"/><path d="M19 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/></Icon>;
const IconCamera    = () => <Icon><rect x="2" y="6" width="14" height="12" rx="2"/><path d="m16 10 6-3v10l-6-3"/></Icon>;
const IconMixer     = () => <Icon><path d="M6 4v16M12 4v16M18 4v16"/><rect x="4" y="13" width="4" height="3" rx="1"/><rect x="10" y="7" width="4" height="3" rx="1"/><rect x="16" y="11" width="4" height="3" rx="1"/></Icon>;
const IconBroadcast = () => <Icon><circle cx="12" cy="12" r="2"/><path d="M8.5 8.5a5 5 0 0 0 0 7M15.5 8.5a5 5 0 0 1 0 7M5.6 5.6a9 9 0 0 0 0 12.8M18.4 5.6a9 9 0 0 1 0 12.8"/></Icon>;
const IconCalendar  = () => <Icon><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></Icon>;
const IconPhone     = () => <Icon><rect x="7" y="2" width="10" height="20" rx="2"/><path d="M11 18h2"/></Icon>;
const IconWebcam    = () => <Icon><circle cx="12" cy="10" r="7"/><circle cx="12" cy="10" r="2.5"/><path d="M8 21h8M12 17v4"/></Icon>;
const IconScreen    = () => <Icon><rect x="2" y="4" width="20" height="13" rx="2"/><path d="M8 21h8M12 17v4"/></Icon>;
const IconHeadset   = () => <Icon><path d="M4 14v-2a8 8 0 0 1 16 0v2"/><rect x="2" y="14" width="5" height="6" rx="1.5"/><rect x="17" y="14" width="5" height="6" rx="1.5"/></Icon>;
const IconArrow     = () => <Icon><path d="M5 12h14M13 6l6 6-6 6"/></Icon>;
const IconGlobe     = () => <Icon><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></Icon>;
const IconMegaphone = () => <Icon><path d="M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1z"/><path d="M15 9a4 4 0 0 1 0 6M18 6.5a8 8 0 0 1 0 11"/></Icon>;
const IconEyeOff = () => <Icon><path d="M3 3l18 18"/><path d="M10.6 5.1A10 10 0 0 1 12 5c6 0 10 7 10 7a17 17 0 0 1-3.2 3.9M6.6 6.6A17 17 0 0 0 2 12s4 7 10 7a9.6 9.6 0 0 0 5.4-1.6"/><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/></Icon>;

export default Login;
